var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSystem = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.78978 4.08008H16.3896C16.783 4.08008 17.0397 4.40243 17.0397 4.80008V8.04008C17.0397 8.20459 17.1575 8.44222 17.2597 8.57026L18.2997 9.84008C18.4019 9.96811 18.4797 10.2156 18.4797 10.3801V19.3801C18.4797 19.7777 18.153 20.1001 17.7597 20.1001H6.41971C6.02639 20.1001 5.69971 19.7777 5.69971 19.3801V10.3801C5.69971 10.2156 5.77753 9.96811 5.87971 9.84008L6.9197 8.57026C7.02188 8.44222 7.13971 8.20459 7.13971 8.04008V4.80008C7.13971 4.40243 7.39645 4.08008 7.78978 4.08008Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSystem, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/system.769755ff.svg";
export { ForwardRef as ReactComponent };